import { render, staticRenderFns } from "./NotificationCentral.vue?vue&type=template&id=260d88a8&scoped=true"
import script from "./NotificationCentral.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationCentral.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationCentral.vue?vue&type=style&index=0&id=260d88a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d88a8",
  null
  
)

export default component.exports